import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/user'
import './utils/runtime-error-handler'

// 全局错误处理 - 确保任何错误都能被捕获
const errorHandler = (err, instance, info) => {
  console.error('Vue Error:', err)
  console.error('Component:', instance)
  console.error('Info:', info)

  // 隐藏加载动画
  hideLoading()

  // 如果是关键错误，尝试跳转到登录页
  if (isCriticalError(err)) {
    redirectToLogin()
  }
}

// 判断是否是关键错误
function isCriticalError(err) {
  if (!err) return false
  const msg = err.message || err.toString()
  return (
    msg.includes('Failed to fetch') ||
    msg.includes('Loading chunk') ||
    msg.includes('dynamically imported module') ||
    msg.includes('Cannot find module') ||
    msg.includes('NetworkError')
  )
}

// 隐藏加载动画
function hideLoading() {
  const loading = document.getElementById('app-loading')
  if (loading) {
    loading.style.display = 'none'
  }
}

// 跳转到登录页
function redirectToLogin() {
  console.log('Redirecting to login page due to error...')
  // 清除可能损坏的数据
  try {
    localStorage.removeItem('login_data')
  } catch (e) {
    // ignore
  }
  // 延迟跳转，让用户看到错误信息
  setTimeout(() => {
    window.location.href = '/login'
  }, 1000)
}

// 创建应用
let app = null
try {
  app = createApp(App)
  app.config.errorHandler = errorHandler
  app.config.warnHandler = (msg, instance, trace) => {
    console.warn('Vue Warning:', msg)
  }
} catch (err) {
  console.error('Failed to create Vue app:', err)
  hideLoading()
  redirectToLogin()
  throw err
}

const pinia = createPinia()

// 使用插件
app.use(pinia)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
  size: 'default',
})

// 初始化：从 localStorage 恢复登录状态
// 使用 async/await 确保初始化完成后再挂载应用
async function initApp() {
  console.log('[LSV] initApp start')
  try {
    const userStore = useUserStore()
    userStore.loadFromStorage()
    console.log('[LSV] user store loaded, isLoggedIn=', userStore.isLoggedIn)
  } catch (error) {
    console.error('Failed to initialize user store:', error)
    // 清除可能损坏的数据
    try {
      localStorage.removeItem('login_data')
    } catch (e) {
      // ignore
    }
  }

  // 确保应用挂载在 DOM 准备好之后
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      mountApp()
    })
  } else {
    mountApp()
  }
}

// 挂载应用
function mountApp() {
  try {
    console.log('[LSV] mounting app...')
    app.mount('#app')
    console.log('App mounted successfully')
    // 注意：加载动画的隐藏由 App.vue 的 onMounted 处理
  } catch (err) {
    console.error('Failed to mount app:', err)
    hideLoading()
    redirectToLogin()
  }
}

// 启动应用
initApp().catch((err) => {
  console.error('Init app failed:', err)
  hideLoading()
  redirectToLogin()
})
